export default __webpack_public_path__ + "static/aboutIllustration-1d2bfd1332aaf6c914b263874f71eac7.svg";